module.exports = "/img/26.9c6f3e.webp";